$(function () {
  var host = "https://dip.sylvoxtv.com/api/api";
  const quantityList = ["1-5 units", "6-10 units", "More than 10 units"];
  const sizeList = [
    "43 inch",
    "55 inch",
    "65 inch",
    "75 inch",
    "Other",
  ];
  const typeList = [
    "Partial Sun Outdoor TV",
    "Full Sun Outdoor TV",
    "Outdoor TV Cabinet",
    "Outdoor Digital Signage",
    "Kitchen TV",
    "Bathroom TV",
    "12V RV TV",
    "Portable TV",
  ];
  const payList = ["Online Order", "Offline Payment"];
  // 动态渲染select option
  function getSelectList(arr, id) {
    $(`#${id}`).find(".el-select__list").empty();
    arr.forEach(function (opt) {
      $(`#${id}`)
        .find(".el-select__list")
        .append(`<li class="el-select__item" data-value="${opt}">${opt}</li>`);
    });
  }
  getSelectList(quantityList, "quantityDrop");
  getSelectList(sizeList, "sizeDrop");
  getSelectList(typeList, "typeDrop");
  getSelectList(payList, "payDrop");
// 弹窗展示
    $("#buyInBulkForm").on('click',function () {
        $('#buyingInBulkForm').show();
        $('.form-success-contair').hide()
         $("#myModal").fadeIn(150);
         disableScroll();
    })   
  // 移除错误样式
  $("#email").on("change", function () {
    $(this).removeClass("error-input");
  });
  $("#userName").on("change", function () {
    $(this).removeClass("error-input");
  });
  $("#cellPhone").on("change", function () {
    $(this).removeClass("error-input");
  });
  var submitBoolen = false;
  // 弹窗逻辑
  $("#submitBtn").on("click", function () {
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    var hasError = false;
    var requiredFields = [
      { input: "#formQuantitySelect",id:'#quantitySelect' },
      { input: "#formSizeSelect" ,id:'#sizeSelect'},
      { input: "#formTypeSelect",id:'#typeSelect' },
      { input: "#email" ,id:'#email'},
      { input: "#userName" ,id:'#userName'},
      { input: "#cellPhone",id:'#cellPhone' },
    ];
    requiredFields.forEach(function (f) {
      var $input = $(f.input);
      var val = $input.val();
      if (!val) {
        if (
          f.input == "#formQuantitySelect" ||
          f.input == "#formSizeSelect" ||
          f.input == "#formTypeSelect"
        ) {
          $(f.id).find(".el-select__input").addClass("error-input");
        } else {
          $input.addClass("error-input");
        }
        hasError = true;
      }
    });
    if (hasError) {
      showToast("Incomplete required fields");
      return;
    }
    submitForm();
  });
  function submitForm() {
    // 获取表单数据
    var formData = new FormData();
    formData.append("number", $("#formQuantitySelect").val());
    formData.append("productSize", $("#formSizeSelect").val());
    formData.append("email", $("#email").val());
    formData.append("productType", $("#formTypeSelect").val());
    formData.append("payType", $("#formPaySelect").val());
    formData.append("name", $("#userName").val());
    formData.append("phone", $("#cellPhone").val());
    formData.append("remark", $("#remark").val());
    $("#submitBtn").prop("disabled", true).html("Submitting...");
    showFullscreenLoading();
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    submitBoolen = true;
    // 发送请求
    $.ajax({
      url: host + "/addShopifyOrders",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData,
      success: function (res) {
        if (res.Code == 0) {
          showToast("Submission Successful");
          $('#buyingInBulkForm').hide();
          $('.form-success-contair').show()
        } else {
          showToast(res.Msg);
        }
      },
      error: function (xhr) {
        showToast("Submit failed");
      },
      complete: function () {
        $("#submitBtn").prop("disabled", false).html("Submit");
        hideFullscreenLoading();
        submitBoolen = false;
      },
    });
  }
  $("#modalClose").on("click", function () {
    $("#myModal").fadeOut(150);
    enableScroll();
    resetForm();
  });
  // 文本域字数统计
  $("#remark").on("input", function () {
    var len = $(this).val().length;
    $("#descCounter").text(len + "/2000");
  });
    //重置参数
    function resetForm() {
        $('#formQuantitySelect').val('');
        $('#quantityEdit').val('');
        $('#formSizeSelect').val('');
        $('#sizeEdit').val('');
        $('#formTypeSelect').val('');
        $('#typeEdit').val('');
        $('#formPaySelect').val('');
        $('#payEdit').val('');
        $('#userName').val('');
        $('#email').val('');
        $('#cellPhone').val('');
        $('#remark').val('');
    }   
  // Toast 提示框
  function showToast(msg, duration) {
    duration = duration || 2000;
    var $toast = $("#globalToast");
    $toast.text(msg).addClass("show");
    clearTimeout($toast.data("timer"));
    var timer = setTimeout(function () {
      $toast.removeClass("show");
    }, duration);
    $toast.data("timer", timer);
  }
  function showFullscreenLoading() {
    $(".loader-content").find("#loader-text").css("display", "none");
    let contentText =
      '<p class="loader-text" style="margin:0;">We will contact you as soon as possible after receiving your information...</p>';
    $(".loader-content").append(contentText);
    PageLoader.show();
  }
  function hideFullscreenLoading() {
    $(".loader-content").find("#loader-text").css("display", "block");
    $(".loader-content .loader-text").remove();
    PageLoader.hide();
  }
  $('.el-select').each(function(){
    selectDrop($(this).attr('id'),)
  })

  function selectDrop(id) {
    let selectList = [];
    let name = ''
    switch (id) {
      case "quantitySelect":
        selectList = quantityList;
        name = 'Quantity'
        break;
      case "sizeSelect":
        selectList = sizeList;
        name = 'Size'
        break;
      case "typeSelect":
        selectList = typeList;
        name = 'Type'
        break;
      case "paySelect":
        selectList = payList;
        name = 'Pay'
        break;
    }
    const $select = $(`#${id}`);
    const $input = $select.find(".el-select__input");
    const $editor = $select.find(".el-select__editor");
    const $dropdown = $select.find(".el-select__dropdown");
    const $arrow = $select.find(".el-select__arrow");
    const $list = $select.find(".el-select__list");

    // 展开/收起下拉框
    $input.on("click", function (e) {
      e.stopPropagation();
      if (e.target === $editor[0]) return;
      closeOther()
      toggleDropdown();
    });

    // 编辑器获取焦点时自动展开
    $editor.on("focus", function () {
      if (!$dropdown.hasClass("el-select__dropdown--visible")) {
        closeOther()
        toggleDropdown(true);
      }
    });

    // 输入内容时过滤选项
    $editor.on("input", function () {
      const keyword = $(this).val();
      $list.empty();
      const filtered = selectList.filter((item) => item.includes(keyword));
      if (filtered.length === 0) {
        $list.append(
          '<li style="color:#999;text-align:center;">No Matched</li>'
        );
        return;
      }
      filtered.forEach((item) => {
        $list.append(
          `<li class="el-select__item" data-value="${item}">${item}</li>`
        );
      });
    });

    // 选择选项
    $list.on("click", ".el-select__item", function () {
      const $item = $(this);
      const value = $item.data("value");
      if (!value) return;
      $(`#form${name}Select`).val(value);
      $input.removeClass("error-input");
      const text = $item.text();
      $editor.val(text);
      $list.find(".el-select__item").removeClass("el-select__item--selected");
      $item.addClass("el-select__item--selected");
      toggleDropdown(false);
      // 触发change事件
      $select.trigger("change", { value, text });
    });

    // 点击页面其他区域收起下拉框
    $(document).on("click", function (e) {
      if (!$editor.val() && $(`#form${name}Select`).val() !== "") {
        const value = $(`#form${name}Select`).val();
        const text = selectList.filter((item) => item == value);
        $editor.val(text[0]);
      }

      if (!$dropdown.hasClass("el-select__dropdown--visible")) return;
      toggleDropdown(false, "body");
    });
    function toggleDropdown(show, type) {
      const isVisible =
        typeof show === "boolean"
          ? !show
          : $dropdown.hasClass("el-select__dropdown--visible");
      $dropdown.toggleClass("el-select__dropdown--visible");
      $input.toggleClass("el-select__input--focus");
      $arrow.css("transform", isVisible ? "rotate(0deg)" : "rotate(180deg)");
    }
    function closeOther() {
        let closeId = ['quantitySelect','sizeSelect','typeSelect','paySelect'];
        for (let index = 0; index < closeId.length; index++) {
            const val = closeId[index];
            if(val == id){continue}
            $(".el-select__dropdown").removeClass("el-select__dropdown--visible");
            $(".el-select__input").removeClass("el-select__input--focus");
            $(".el-select__arrow").css("transform", "rotate(0deg)");
        }
        
    }
  }
  // 存储原始滚动位置
    let scrollPosition = 0;

    // 禁止滚动函数
    function disableScroll() {
    scrollPosition = $(window).scrollTop();
    $('body').css({
        'overflow': 'hidden',
        'position': 'fixed',
        'top': -scrollPosition + 'px',
        'width': '100%'
    });
    }

    // 恢复滚动函数
    function enableScroll() {
        $('body').css({
            'overflow': '',
            'position': '',
            'top': '',
            'width': ''
        });
        $(window).scrollTop(scrollPosition);
    }

    // 处理浏览器窗口大小变化
    $(window).resize(function() {
    if ($('body').css('overflow') === 'hidden') {
        $('body').css('top', -$(window).scrollTop() + 'px');
    }
    });
});
